import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

/**
 * Dropdown inline pra vincular um recurso (oauth_account ou page) a um projeto.
 *
 * Convenção: o backend recebe `project_id=null` pra "remover vínculo" / "herdar".
 * No frontend usamos o sentinel `__none__` no Select (shadcn não aceita value="").
 */

interface ProjectOption {
    id: number;
    name: string;
}

interface ProjectInlineSelectorProps {
    value: number | null;
    onChange: (project_id: number | null) => void;
    projects: ProjectOption[];
    /** Nome do projeto default a mostrar como hint (ex: projeto da conta) — só
     *  pra page-level override. */
    inheritHintName?: string | null;
    disabled?: boolean;
    /** Texto do item "sem projeto" — varia conforme contexto (page herda da conta,
     *  conta vira "Nenhum"). */
    noneLabel?: string;
    placeholder?: string;
    className?: string;
}

const NONE = '__none__';

export default function ProjectInlineSelector({
    value,
    onChange,
    projects,
    inheritHintName,
    disabled,
    noneLabel = 'Nenhum',
    placeholder = 'Selecionar projeto…',
    className,
}: ProjectInlineSelectorProps) {
    return (
        <Select
            value={value == null ? NONE : String(value)}
            onValueChange={(v) => onChange(v === NONE ? null : Number(v))}
            disabled={disabled}
        >
            <SelectTrigger className={className || 'h-8 text-xs min-w-[180px]'}>
                <SelectValue placeholder={placeholder}>
                    {value == null
                        ? (inheritHintName
                            ? <span className="block truncate text-gray-500">Herda da conta · {inheritHintName}</span>
                            : <span className="block truncate text-gray-500">{noneLabel}</span>)
                        : <span className="block truncate">{projects.find(p => p.id === value)?.name || `#${value}`}</span>}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                <SelectItem value={NONE}>
                    <span className="text-gray-500">
                        {inheritHintName ? `Herda da conta · ${inheritHintName}` : noneLabel}
                    </span>
                </SelectItem>
                {projects.map(p => (
                    <SelectItem key={p.id} value={String(p.id)}>
                        {p.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
